import { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { updateOrganizationDetails } from "../../../shared/lib/graphql"
import logPlatformUserAction from "../../utils/log_platform_user_action"

import "./tier_style.scss"

export class OrganizationDetails extends Component {
  state = {
    orgName: this.props.org.name,
    formDisabled: false,
  }

  updateOrgNameField = e => {
    this.setState({
      orgName: e.target.value,
    })
  }

  updateOrg = e => {
    e.preventDefault()
    this.setState(
      {
        formDisabled: true,
      },
      () => {
        updateOrganizationDetails(
          this.props.org.id,
          this.state.orgName
        )
          .then(() => {
            logPlatformUserAction(
              this.props.org.id,
              null,
              "organization_details",
              "updated"
            )

            window.appendFlash("Organization updated", "success")

            window.location.reload()
          })
          .catch(() => {
            window.appendFlash(
              "An error has occrurred, please contact customer support",
              "danger"
            )
          })
          .then(() => {
            this.setState({ formDisabled: false })
          })
      }
    )
  }

  render() {
    const { orgName } = this.props
    return (
      <>
        <header className="page-header">
          <h1>{orgName} Details</h1>
        </header>
        <p>
          Your organization name is not shared publicly and
          can only be modified by the organization owner.
        </p>
        <form className="form" onSubmit={this.updateOrg}>
          <section className="form-section">
            <div className="field">
              <div className="label">
                <label>Organization name</label>
              </div>
              <div className="input">
                <input
                  required={true}
                  type="text"
                  id="name"
                  value={this.state.orgName}
                  onChange={this.updateOrgNameField}
                />
              </div>
            </div>

            <div className="action">
              <button
                type="submit"
                value="Save"
                className="button-secondary"
                disabled={
                  this.state.formDisabled ||
                  this.props.currentUserId !== this.props.orgOwner.id
                }
              >
                {this.state.formDisabled ? "Saving..." : "Save"}
              </button>
            </div>
          </section>
        </form>

        <div styleName="org-options">
          <h3>Merge organization</h3>
          <p>
            If {"you'd"} like to merge the{" "}
            <b>{this.props.org.name} organization</b> with another organization
            you own to manage team members, services, or Applets in one place,{" "}
            <a
              className="pop-zendesk-widget"
              styleName="contact-us"
              href="mailto:platform-support@ifttt.com"
            >
              {" "}
              contact us
            </a>
            .
          </p>
        </div>
      </>
    )
  }
}
const mapStateToProps = state => {
  return {
    orgName: state.details.orgName,
    orgOwner: state.details.orgOwner,
  }
}

export default connect(mapStateToProps)(OrganizationDetails)

OrganizationDetails.propTypes = {
  orgOwner: PropTypes.object,
  org: PropTypes.object,
  orgName: PropTypes.string,
  currentUserId: PropTypes.string,
  dispatch: PropTypes.func,
}
